import * as React from "react";
import { Field } from "react-final-form";
import { TipoAgrupadoras } from "../../documentos/modelo/TipoAgrupadoras";

export default class TipoAgrupadora extends React.Component<TipoAgrupadoraProps> {

    render() {
        const { className, excluir, disabled } = this.props;
        const tiposClientes = this.filtrarTiposCliente(excluir);
        return (
            <Field
                component="select"
                name={this.props.name}
                disabled={disabled}
                className={className ? className.concat(" form-control") : "form-control"}>
                {({ input, meta }) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {tiposClientes.map(tipo => {
                                return <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

    filtrarTiposCliente = (excluir: Array<string>) => {
        return TipoAgrupadoras.filter(tc => {
            return !excluir || excluir.indexOf(tc.id) === -1;
        });
    }
}

interface TipoAgrupadoraProps {
    name: string,
    className?: string,
    excluir?: Array<string>,
    disabled?: boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TipoAgrupadora.tsx